import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListarVinculoProdutoService {

  constructor(private http: HttpService, private httpService:HttpService) { }

  buscaFuncionarios(params:any, successHandle:Function, errorHandle:Function) {
    return this.http.doGet('/employeeRequestCard', params,successHandle,errorHandle);
 }


}
